import TSZahlungsauftragDTO from './TSZahlungsauftragDTO';
export default class TSZahlungsauftraegeSearchresultDTO {

    private _zahlungsauftragDTOs: Array<TSZahlungsauftragDTO> = [];
    private _totalResultSize: number = 0;

    public get zahlungsauftragDTOs(): Array<TSZahlungsauftragDTO> {
        return this._zahlungsauftragDTOs;
    }

    public set zahlungsauftragDTOs(value: Array<TSZahlungsauftragDTO>) {
        this._zahlungsauftragDTOs = value;
    }

    get totalResultSize(): number {
        return this._totalResultSize;
    }

    set totalResultSize(value: number) {
        this._totalResultSize = value;
    }

    public parseZahlungsauftragDTOs(data: any): TSZahlungsauftragDTO[] {
        let zahlungsauftragDTO: TSZahlungsauftragDTO[] = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                zahlungsauftragDTO[i] = new TSZahlungsauftragDTO().deserialize(data[i]);
            }
        } else {
            zahlungsauftragDTO[0] = new TSZahlungsauftragDTO().deserialize(data);
        }
        return zahlungsauftragDTO;
    }

    deserialize(restObject: any): TSZahlungsauftraegeSearchresultDTO {

        this.zahlungsauftragDTOs = this.parseZahlungsauftragDTOs(restObject.zahlungsauftragDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSZahlungsauftraegeSearchresultDTO.ts